import { render } from "./navbar.vue?vue&type=template&id=4c374498&scoped=true"
const script = {}

import "./navbar.vue?vue&type=style&index=0&id=4c374498&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c374498"]])

export default __exports__